import { Link } from "react-router-dom";
import { Reveal, SectionHeading } from "@/components/site/Reveal";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { GALLERY } from "@/lib/site";

export const ProjectPreview = () => {
  const item = GALLERY[0];
  return (
    <section className="bg-white py-20 md:py-28" data-testid="home-projects">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid gap-12 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-4">
          <SectionHeading eyebrow="Project gallery" title="See the difference."
            intro="A kitchen wall we repaired and repainted. Drag the slider to compare before and after." />
          <Reveal delay={0.2} className="mt-8">
            <Link to="/gallery" data-testid="home-gallery-link"
              className="inline-flex rounded-full bg-[var(--navy)] px-7 py-3.5 font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5">
              Open the gallery
            </Link>
          </Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-8">
          <BeforeAfter testId="home-before-after" before={item.before} after={item.after}
            beforeAlt={item.beforeAlt} afterAlt={item.afterAlt} real={item.real} className="aspect-[4/3] md:aspect-[16/10]" />
        </Reveal>
      </div>
    </section>
  );
};
